export default __webpack_public_path__ + "static/media/p47.e8c4e0de.jpg";